import React from "react";
import { Link } from "react-router-dom";
import { Calculator } from "lucide-react";
import ThemeToggle from "@/components/ui/theme-toggle";
import CalculatorSwitcher from "./CalculatorSwitcher";

// ============================================================
// FYUNOR — Header
// Minimal: brand, theme toggle, and the calculator switcher.
// No sign-in, no search, no mega-menu — the switcher is the nav.
// ============================================================

export default function Header() {
  return (
    <header className="sticky top-0 z-50 glass-ribbon border-b border-border">
      <div className="container-fyunor flex h-14 items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <span className="flex size-7 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Calculator className="size-4" aria-hidden="true" />
          </span>
          <span className="font-display text-lg font-bold tracking-[var(--tracking-display)] text-foreground">
            Fyunor
          </span>
        </Link>
        <ThemeToggle />
      </div>
      <div className="container-fyunor">
        <CalculatorSwitcher />
      </div>
    </header>
  );
}